var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1132c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0522a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08379d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042a7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc63c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.619048 0h8.380952v11.428571h-8.380952z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.333333v11.428571h-5.333333z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.333333 0h5.333333v11.428571h-5.333333z",
    fill: "url(#e)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.90725257 3.58748082c.05968549-.08776324.15705547-.08392334.21187916 0l.53896397.82503836c.05733219.08776324.01452335.1589094-.0896506.1589094l-.18450925.00000001c-.1068448.00000001-.18527513.08184525-.17449974.18959955l.15255635 1.5255628c.01047124.10471293.10731558.18959954.20943611.18959954.10519711 0 .25-.0588844.32800876-.13605516l.10588724-.10474981c.07595718-.07514119.13753257-.21803025.13753257-.32934854v-.37941024c0-.106753-.05952381-.25281721-.13753257-.33082595l-.10588724-.10588728c-.07595718-.07595713-.06254651-.16252789.04103886-.19705635l.78571429-.26190474c.09862224-.03287409.16351916.02232143.14370194.13007573l-.280568 1.5255628c-.01925783.10471293-.09705951.24938492-.17292114.32231322l-.51644678.49647739c-.07624389.07329575-.2264074.13271369-.32852793.13271369-.1051971 0-.19047619.08153716-.19047619.19226074v.3773833c0 .10618262-.08153714.19226072-.19226072.19226072h-.37738332c-.10618263 0-.19226072-.08153714-.19226072-.19226072v-.3773833c0-.10618268-.08835566-.19226074-.19047619-.19226074-.1051971 0-.25026158-.05978539-.32318988-.13271369l-.49647739-.49647739c-.07329575-.07329575-.14908273-.21455892-.17063359-.32231322l-.30511257-1.5255628c-.02094259-.10471293.03706614-.16460419.14065152-.13007573l.78571429.26190474c.09862228.03287409.11904762.11904761.04103888.19705635l-.10588728.10588728c-.07595713.07595713-.13753255.21950765-.13753255.33082595v.37941024c0 .10675299.05952381.25217778.13753255.32934854l.10588728.10474981c.07595713.07514119.22588821.13605516.32800874.13605516.1051971 0 .19866072-.08184525.20943611-.18959954l.15255635-1.52556283c.01047123-.10471293-.07032579-.18959954-.17449973-.18959954h-.18450927c-.10684482 0-.14246358-.07498605-.0853895-.15890939z",
    fill: "url(#f)",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/BB.810418645e398001cff8ba55e895111b.svg";
export { ForwardRef as ReactComponent };